// filepath: c:\Users\gelis\Documents\GitHub\PisikolojiWeb\frontend\src\features\content\contentSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// Değişiklik burada: contentService'i aynı klasörden import ediyoruz
import contentService from './contentService';

const initialState = {
  content: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

// Sayfa içeriğini getir
export const getContent = createAsyncThunk(
  'content/get',
  async (page, thunkAPI) => {
    try {
      return await contentService.getContent(page);
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Sayfa içeriğini güncelle
export const updateContent = createAsyncThunk(
  'content/update',
  async ({ page, contentData }, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.userInfo.token;
      return await contentService.updateContent(page, contentData, token);
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    resetContent: (state) => {
      state.content = null;
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getContent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.content = action.payload;
      })
      .addCase(getContent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.content = null;
      })
      .addCase(updateContent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateContent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.content = action.payload;
      })
      .addCase(updateContent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { resetContent } = contentSlice.actions;
export default contentSlice.reducer;